export default __webpack_public_path__ + "static/media/policy-logs.277e02fc.png";